// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"331":"64ad479d8f3f9b04","584":"55cc76eb8d5d57d2","869":"33989b789884926d"}[chunkId] + ".js";
};